/** Mirrors server capabilities. Copy is derived from flags + sttConfigured. No keys. */
import {
  LANGUAGE_CAPABILITIES,
  SHIPPED_LANGUAGE_CAPABILITIES,
  TEXT_LANGUAGE_CHIPS,
  voiceCopy,
  voiceHeadline,
  voiceStatCaption,
  countTextLanguages
} from '@byonco/voice/languages.js';

export const LANGUAGE_IO = LANGUAGE_CAPABILITIES;
export { LANGUAGE_CAPABILITIES, SHIPPED_LANGUAGE_CAPABILITIES, TEXT_LANGUAGE_CHIPS };
export { voiceCopy, voiceHeadline, voiceStatCaption, countTextLanguages };
export const VOICE_COPY = voiceCopy(LANGUAGE_IO, { sttConfigured: false });
export const VOICE_HEADLINE = voiceHeadline(LANGUAGE_IO, { sttConfigured: false });
